<template>
    <div class="manager__main-area options">
        <div class="container-tab">
            <div class="tab" :class="{ active: activeTab === 'products' }" @click="activeTab = 'products'">
                <span>Produtos</span>
            </div>
            <div class="tab" :class="{ active: activeTab === 'categories' }" @click="activeTab = 'categories'">
                <span>Categorias</span>
            </div>
            <div class="tab" :class="{ active: activeTab === 'brands' }" @click="activeTab = 'brands'">
                <span>Marcas</span>
            </div>
            <div class="tab" :class="{ active: activeTab === 'brandProducts' }" @click="activeTab = 'brandProducts'">
                <span>Associar marca ao produto</span>
            </div>
        </div>
        <app-perfect-scrollbar style="height: 100%;">
            <app-manage-products v-if="activeTab === 'products'"></app-manage-products>
            <app-manage-categories v-if="activeTab === 'categories'"></app-manage-categories>
            <app-manage-brands v-if="activeTab === 'brands'"></app-manage-brands>
            <app-manage-brand-products v-if="activeTab === 'brandProducts'"></app-manage-brand-products>
        </app-perfect-scrollbar>
    </div>
</template>

<script>
import ManageProductsComponent from './ManageProducts'
import ManageCategoriesComponent from './ManageCategories.vue'
import ManageBrandsComponent from './ManageBrands.vue'
import ManageBrandProductsComponent from './ManageBrandProducts.vue'

export default {
    components: {
        'app-manage-products': ManageProductsComponent,
        'app-manage-categories': ManageCategoriesComponent,
        'app-manage-brands': ManageBrandsComponent,
        'app-manage-brand-products': ManageBrandProductsComponent
    },
    data() {
        return {
            activeTab: 'products'
        }
    },
    computed: {
    },
    methods: {

    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
.options.manager__main-area {
    width: 100%;
    background-color: var(--bg-color--2);
    padding: 70px;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    height: 100%;
}

.tab {
    display: flex; 
    flex-direction: row; 
    margin-right: 1px;

    padding: 7px 10px 5px 12px;
    background: #23272B;
    font-size: 14px;
    height: 32px;
    display: flex;
    cursor: pointer;
    span.has {
        color: #C3C5C6
    }
    &.active {
        background-color: #31363C;
        span {
            color: #4d76c8;
        }
    }
    &:first-child {
        border-top-left-radius: 5px;
    }
    &:last-child {
        margin-right: 0;
        border-top-right-radius: 5px;
    }
}

.container-tab {
    display: flex;

}
</style>